export default "__VITE_ASSET__CC7Y388N__"